import React, { useState } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

import OTPInputField from "../../ui/CustomOtpInput/OTPInputField";
import {
  useConfirmOtpForgotPassword,
  useConfirmOtpTowStepLogin,
} from "../../lib/queries/queriesAndMutations";

const TowStepOtpVerification = () => {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const { state } = useLocation();
  const { mutateAsync: confirmOtp, isPending } = useConfirmOtpTowStepLogin();

  const towFaType = state?.towFaType || "sms";
  const phone = state?.phone;

  const typeMessages = {
    sms: "پیامک",
    email: "ایمیل",
    google: "google authenticator",
  };

  const message = typeMessages[towFaType] || "نامشخص";

  const processForm = async () => {
    if (!phone) {
      toast.error("شماره تلفن را وارد نمایید");
      return;
    }
    if (String(otp).length !== 6) {
      toast.error(" کد ارسالی 6 رقمی است");
      return;
    }
    try {
      const response = await confirmOtp({ phone, otp });
      if (response.status === 200) {
        Cookies.set("token", response.data.token, { expires: 30 });
        navigate("/home");
        toast.success("شما با موفقیت وارد ناحیه کاربری شدید.");
      }
    } catch (error) {
      // toast.error("خطا در تایید کد. لطفا دوباره تلاش کنید.");
      console.error(error);
    }
  };

  return (
    <div className="flex flex-col gap-8 items-center">
      <div className="bg-white p-6 rounded-md shadow-md w-full max-w-lg">
        <p className="text-[#7f7f7f] text-[20px] mb-6 font-bold text-center leading-relaxed">
          کاربر گرامی، جهت ورود کد تایید ۶ رقمی ارسال‌شده از طریق{" "}
          <span className="text-black text-[22px] mb-8  font-bold">
            {message}
          </span>{" "}
          را وارد نمایید
        </p>
        <div className="flex flex-col items-center gap-4">
          <div className="bg-neutral-30 p-4 shadow-sm rounded-lg" dir="ltr">
            <OTPInputField
              value={otp}
              handleChange={setOtp}
              styleObject={{ backgroundColor: "#F0F0F0" }}
              numOfInputs={6}
            />
          </div>
          <button
            onClick={() => processForm()}
            disabled={isPending}
            className="text-[#FFFFFF] bg-[#39A78E] hover:bg-[#2A7A67] py-[12px]  px-[70px] rounded mt-4 text-[24px] w-fit mx-auto font-bold"
          >
            تایید کد
          </button>
        </div>
      </div>
    </div>
  );
};

export default TowStepOtpVerification;
